import * as Sentry from '@sentry/nextjs'
import { graphql } from 'gql.tada'
import { useEffect } from 'react'
import { useQuery } from 'urql' // useQuery from urql because we don't want to rethrow error

export function CaptureUserToSentry() {
  const [{ data }] = useQuery({ query: CaptureUserToSentry_Query })

  const userId = data?.currentUser?.id

  // https://docs.sentry.io/platforms/javascript/enriching-events/identify-user/
  useEffect(() => {
    if (userId) Sentry.setUser({ id: userId })
    else Sentry.setUser(null)
  }, [userId])

  return null
}

const CaptureUserToSentry_Query = graphql(`
  query CaptureUserToSentry_Query {
    currentUser {
      ... on Node {
        id
      }
    }
  }
`)
